import { render } from "./OurPasperf.vue?vue&type=template&id=706d64f9&scoped=true"
import script from "./OurPasperf.vue?vue&type=script&lang=js"
export * from "./OurPasperf.vue?vue&type=script&lang=js"

import "./OurPasperf.vue?vue&type=style&index=0&id=706d64f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706d64f9"]])

export default __exports__